import { render } from "./BillingInvoices.vue?vue&type=template&id=24e73b30&scoped=true"
import script from "./BillingInvoices.vue?vue&type=script&lang=js"
export * from "./BillingInvoices.vue?vue&type=script&lang=js"

import "./BillingInvoices.vue?vue&type=style&index=0&id=24e73b30&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e73b30"]])

export default __exports__